module.exports = __webpack_public_path__ + "img/animation-curve-editor.a99888a7.jpg";